export default "__VITE_ASSET__Ctm6XWdW__ 640w, __VITE_ASSET__C6FHzm8w__ 1024w";